import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import AgGrid from '../../shared/agGrid/agGrid.component';
import withPillNavigation from '../../shared/withPillNavigation.decorator';
import { decodeCountryTaxType } from '../../utils/encodeDecodeCTT';

import { BookTypePills, BookTypePillTypes } from '../../shared/bookTypePills';
import { viewTaxEntriesColumnDefs } from '../../shared/columnDefinitions/taxEntriesColumnDefs';
import { YES_FLAG } from '../../shared/constants';
import { taxEntryPropType } from './propTypes';

class TaxEntriesGrid extends PureComponent {
  static propTypes = {
    fetchTaxEntryData: PropTypes.func.isRequired,
    taxEntries: PropTypes.arrayOf(taxEntryPropType),
    taxEntriesLoading: PropTypes.bool,
  };

  fetchTaxEntryData = params => {
    const selectedRows = params.api.getSelectedRows();
    if (selectedRows.length === 0) {
      return;
    }
    const selectedTaxEntryId = selectedRows[0].taxEntryId;
    this.props.fetchTaxEntryData(selectedTaxEntryId);
  };

  selectFirstRow = params => {
    if (this.props.taxEntries.length) {
      const deselectOthers = true;
      params.api.getModel().getRow(0).setSelected(true, deselectOthers);
    }
  };

  render() {
    const {
      taxEntries,
      taxEntriesLoading,
    } = this.props;

    const taxEntriesWithDecodedTaxTypes = taxEntries.map(taxEntry => {
      const { countryCode, countryTaxType } = decodeCountryTaxType(taxEntry.countryTaxType);

      return {
        ...taxEntry,
        countryCode,
        countryTaxType,
      };
    });

    return (
      <div className="tax-entries-grid">
        <div className="row no-gutters">
          <div className="col">
            <div className="d-flex flex-row justify-content-between">
              <h5>Tax Entries</h5>
            </div>
          </div>
        </div>
        <div className="ag-theme-bootstrap">
          <AgGrid
            columnDefs={viewTaxEntriesColumnDefs}
            headerHeight={50}
            rowData={taxEntriesWithDecodedTaxTypes}
            onSelectionChanged={this.fetchTaxEntryData}
            onRowDataUpdated={this.selectFirstRow}
            isGridLoading={taxEntriesLoading}
          />
        </div>
      </div>
    );
  }
}

export default withPillNavigation(
  ({ statCalc, countryTaxType }) => {
    if (statCalc === YES_FLAG && !['US1', 'US2'].includes(countryTaxType.value)) {
      return BookTypePills;
    }

    return BookTypePills.filter(pill => pill.type === BookTypePillTypes.GAAP);
  },
  {
    propTypes: {
      bookType: PropTypes.string.isRequired,
      countryTaxType: PropTypes.shape({
        label: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
      }),
      selectBookType: PropTypes.func.isRequired,
      statCalc: PropTypes.string.isRequired,
    },
    className: 'page-content-container',
    getActivePill: props => props.bookType,
    onPillChangeEventPropKey: 'selectBookType',
  }
)(TaxEntriesGrid);
